var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useCallback, useContext, useState, useMemo } from 'react';
import { makeStyles, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "../index";
import { useTranslation } from "./useTranslation";
var useStyles = makeStyles(function () { return ({
    root: {},
    content: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    message: {
        textAlign: 'center',
        // preタグに付与されている上下のmarginを上書きする
        margin: 0,
    },
}); });
var defaultOptions = {
    type: 'alert',
    props: {
        message: '',
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: function () { },
};
var DialogButton = React.memo(function (props) {
    return React.createElement(Button, __assign({}, props, { variant: "dialog" }));
});
var AlertContext = createContext({
    alert: function () { return Promise.resolve(); },
    confirm: function () { return Promise.resolve(true); },
});
export var useAlert = function () { return useContext(AlertContext); };
export var AlertProvider = function (_a) {
    var _b, _c;
    var children = _a.children;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(defaultOptions), options = _e[0], setOptions = _e[1];
    var t = useTranslation().t;
    var classes = useStyles();
    var createOpenHandler = useCallback(function (type) { return function (messageOrProps) {
        var alertProps = typeof messageOrProps === 'string' ? { message: messageOrProps } : messageOrProps;
        return new Promise(function (resolve) {
            setOptions({
                type: type,
                props: __assign(__assign({}, defaultOptions.props), alertProps),
                onClose: function (value) {
                    setOpen(false);
                    // ダイアログが閉じるまでのトランジション分delayさせる
                    setTimeout(function () { return resolve(value); }, 100);
                },
            });
            setOpen(true);
        });
    }; }, []);
    var handleOpenAlert = useMemo(function () { return createOpenHandler('alert'); }, [createOpenHandler]);
    var handleOpenConfirm = useMemo(function () { return createOpenHandler('confirm'); }, [createOpenHandler]);
    var createCloseHandler = useCallback(function (value) { return function () { return options.onClose(value); }; }, [options]);
    var handleAlertOK = useMemo(function () { return createCloseHandler(); }, [createCloseHandler]);
    var handleConfirmCancel = useMemo(function () { return createCloseHandler(false); }, [createCloseHandler]);
    var handleConfirmOK = useMemo(function () { return createCloseHandler(true); }, [createCloseHandler]);
    // ダイアログのrootにdata-test-id属性としてpropsに指定されたtestIdをセットする
    var handleDialogRef = useCallback(function (element) {
        if (options.props.dataTestName) {
            element === null || element === void 0 ? void 0 : element.setAttribute('data-test-id', options.type + "-dialog-" + options.props.dataTestName);
        }
    }, [options.props.dataTestName, options.type]);
    return (React.createElement(AlertContext.Provider, { value: {
            alert: handleOpenAlert,
            confirm: handleOpenConfirm,
        } },
        React.createElement(Dialog, { open: open, className: classes.root, ref: handleDialogRef },
            React.createElement(DialogTitle, null, (_b = options.props.title) !== null && _b !== void 0 ? _b : t('確認')),
            React.createElement(DialogContent, { className: classes.content },
                React.createElement("pre", { className: classes.message }, options.props.message)),
            React.createElement(DialogActions, null,
                options.type === 'alert' && (React.createElement(DialogButton, { fill: true, onClick: handleAlertOK }, t('OK'))),
                options.type === 'confirm' && (React.createElement(React.Fragment, null,
                    React.createElement(DialogButton, { onClick: handleConfirmCancel }, t('キャンセル')),
                    React.createElement(DialogButton, { fill: true, onClick: handleConfirmOK }, (_c = options.props.okText) !== null && _c !== void 0 ? _c : t('OK')))))),
        children));
};
